import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cm360-enhanced-conversions-value"
export default class extends Controller {
  static targets = ["select", "hint"]

  connect() {
    if (this.selectTarget.value === "online") {
      this.hintTarget.classList.remove("hidden")
    } else {
      this.hintTarget.classList.add("hidden")
    }
  }

  toggle(event) {
    if (event.target.value === "online") {
      this.hintTarget.classList.remove("hidden")
    } else {
      this.hintTarget.classList.add("hidden")
    }
  }
}
